import { render, staticRenderFns } from "./recording-icon.vue?vue&type=template&id=388bc0fe&scoped=true&"
import script from "./recording-icon.vue?vue&type=script&lang=js&"
export * from "./recording-icon.vue?vue&type=script&lang=js&"
import style0 from "./recording-icon.vue?vue&type=style&index=0&id=388bc0fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388bc0fe",
  null
  
)

export default component.exports